import React from "react";
import { Button, Typography } from "@mui/material";

export const PrimaryButton = ({ onClick, children }) => (
  <Button
    variant="contained"
    sx={{ borderRadius: "15px", textTransform: "none" }}
    onClick={onClick}
  >
    <Typography variant="subtitle2">{children}</Typography>
  </Button>
);
